<template>
  <div class="home">
    <section class="section-cover scroll-reveal">
      <div class="container-btn">
        <h1>Piloter de l’intérieur change tout</h1>
        <p class="mb-20">Coaching personnalisé, fondé sur les neurosciences, pour restaurer votre clarté, votre
          alignement… et votre puissance intérieure.
        </p>
        <p class="span-bold">Pour entrepreneurs, dirigeants et entreprises qui veulent performer sans s’épuiser.
        </p>
        <div class="button">
          <div>
            <p class="text-color text-center">Coaching individuel</p>
            <ButtonLink title="Entrepreneur" to="/entrepreneuriat" />
          </div>
          <div>
            <p class="text-color text-center">Offre pour vos équipes</p>
            <ButtonLink title="Entreprise" to="/entreprise" />
          </div>
          <div>
            <p class="text-color text-center">Testez la méthode</p>
            <ButtonLink title="Session gratuite" :to="{ path: '/a-propos', hash: '#contact-form' }" />
          </div>
        </div>
      </div>
      <div class="cover">
        <img src="../assets/centre.png" alt="" class="cover-image" />
      </div>
      <div class="scroll-btn" @click="scrollDown">
        <i class="bi bi-arrow-down-short"></i>
      </div>
    </section>
    <section id="target" class="section section-light scroll-reveal">
      <h2 style="text-align: left;">Piloter depuis votre Centre<br>
        pour restaurer votre capital intérieur</h2>
      <p>Votre impact extérieur dépend toujours de votre équilibre intérieur.</p>
      <p>Cet équilibre, c’est votre capital intérieur : clarté mentale, énergie, stabilité émotionnelle, convictions
        profondes, relations de qualité…
      </p>
      <p>Pour le restaurer, encore faut-il savoir depuis où le piloter. C’est le rôle du Centre : un espace où le cœur
        guide, l’ego s’apaise et l’esprit s’éclaire.
      </p>
      <p>Quand ce Centre est actif, vos décisions, vos actions et vos relations deviennent plus fluides.</p>
    </section>
    <section class="section scroll-reveal">
      <h2 style="text-align: left;">Et si votre performance dépendait<br> de votre capital intérieur ?</h2>
      <p class="mb-20">Ce n’est pas une question de volonté ou de discipline.
        Vous avez appris à aller vite, à tenir, à faire plus.
        Mais avez-vous appris à vous écouter ? À ralentir sans culpabiliser ? À diriger sans vous effondrer ?

      </p>
      <p class="mb-20">Ce que personne ne vous a dit, c’est que votre capital intérieur,
        pilote tout : votre clarté mentale, votre énergie, vos décisions… même votre posture de leader.
      </p>
      <p>Mais ce capital est orchestré par un Centre de régulation intérieure, souvent oublié,
        là où s’alignent vos ressources physiques, mentales, émotionnelles.
      </p>
      <p>Quand ce Centre est désactivé, vous vous sentez dispersé, en tension ou déconnecté.
        Quand il est réactivé, tout redevient clair, cohérent, stable.
      </p>
    </section>
    <section class="section section-light scroll-reveal">
      <h2>Travailler avec votre système nerveux, c’est...</h2>
      <img src="../assets/pouvoir_regulation.png" alt="" width="350" class="d-block mb-20">
      <p class="mb-20 mt-20">Revenir à l’essentiel, à un espace intérieur stable, ancré, qui ne dépend pas de
        l’extérieur.
        C’est apprendre à écouter les signaux du corps, de vos émotions, du mental… et les remettre au service de votre
        mission.

      </p>
      <p class="span-bold">C’est aussi restaurer un point d’équilibre entre votre cœur, votre ego et votre cerveau.
      </p>
      <p>Ce point de bascule, le Centre, vous ne l’avez jamais appris à cultiver. Et pourtant, il change tout.</p>
      <p>Grâce à une méthode unique, fondée sur 6 dimensions clés de votre écologie intérieure, vous
        retrouvez l’accès à une performance fluide, humaine et durable.</p>
    </section>
    <section class="section scroll-reveal">
      <h2>Vous êtes peut-être ici si...</h2>
      <img src="../assets/regulation.png" alt="" width="350" class="d-block">

      <ul class="row list-offers mb-20 pa-left-32">
        <li>Vous enchaînez les succès, mais vous sentez vos batteries vides</li>
        <li>Vous anticipez tout pour sécuriser vos projets, mais vous n’avez plus d’espace pour souffler.</li>
        <li>Vous avez perdu en clarté et en connexion avec vous-même, votre équipe ou vos proches.</li>
      </ul>
      <p class="span-bold">
        Vous ne cherchez pas plus de contrôle. Vous cherchez un pilotage intérieur stable, un retour à votre Centre pour
        diriger avec clarté et sérénité.
      </p>
    </section>
    <section class="section section-light scroll-reveal">
      <h2>Ce que cette approche transforme</h2>
      <ul class="row list-offers text-center">
        <Card v-for="card in ServiceCard" :key="card.id" :title="card.title" :description="card.description"
          :isMarging="true" isCenter />
      </ul>
      <p class="mt-40">En réalité, tout cela n’est qu’un effet collatéral : vous retrouvez l’accès à votre Centre, et à
        votre capital intérieur.</p>
    </section>
    <section class="section scroll-reveal">
      <StepsSection />
    </section>
    <section class="section section-light scroll-reveal">
      <h2>Refusez de devenir une machine</h2>
      <div>
        <img src="../assets/coeur-relie-cerveau.png" alt="" width="350" class="d-block">
        <p>Vous n’êtes pas ici pour cocher des cases, produire ou forcer.
          Vous êtes ici pour impacter, vivre et diriger avec conscience.
        </p>
        <p>Ce que vous vivez n’est pas un “problème de gestion”.
          C’est un désalignement de votre Centre et de votre capital intérieur.
          Et c’est ce que nous allons recalibrer, ensemble.
        </p>
      </div>
    </section>
    <section class="section scroll-reveal">
      <h2>Une méthode fondée sur la science, la stratégie et l’humain</h2>
      <img src="../assets/trois_s.png" alt="" width="350" class="d-block">
      <p class="mb-20 mt-20">Notre approche repose sur les dernières découvertes en neurosciences appliquées.
        Mais elle va plus loin, elle intègre une vision stratégique du leadership…
        et une connexion profonde à l’intelligence du cœur.
      </p>
      <ul>
        <li>Science</li>
        <li>Stratégie</li>
        <li>Spiritualité</li>
      </ul>
      <p>C’est là que réside la vraie performance, dans cet équilibre subtil entre lucidité, humanité, et retour au
        Centre.
      </p>
    </section>
    <section class="section section-light scroll-reveal">
      <h2>Prêt à passer à l’action ?</h2>
      <p class="text-color">Réservez une consultation gratuite pour découvrir comment la régulation peut transformer
        votre manière de vivre, de diriger et de performer.
      </p>
      <div class="btn-wrapper">
        <ButtonLink title="Réserver une session gratuite" :to="{ path: '/a-propos', hash: '#contact-form' }" />
      </div>
    </section>
  </div>
</template>

<script>
  // @ is an alias to /src
  import ButtonLink from "../components/ButtonLink.vue";
  import Card from "../components/Card.vue";
  import {
    ServiceCard
  } from "../datas.js";

  import StepsSection from "../components/StepsSection.vue";

  export default {
    name: "Home",
    components: {
      ButtonLink,
      Card,
      StepsSection,
    },
    methods: {
      scrollReveal() {
        const reveals = document.querySelectorAll('.scroll-reveal');

        reveals.forEach((element) => {
          const rect = element.getBoundingClientRect();
          if (rect.top < window.innerHeight - 50) {
            element.classList.add('visible');
          }
        });
      },
      scrollDown() {
        const target = document.querySelector('#target');
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    },
    mounted() {
      window.addEventListener('scroll', this.scrollReveal);
      this.scrollReveal();
    },
    beforeUnmount() {
      window.removeEventListener('scroll', this.scrollReveal);
    },
    data() {
      return {
        image: require("../assets/portrait.jpeg"),
        ServiceCard,
      };
    },
  };
</script>
<style lang="scss" scoped>
  $primary-gradient: linear-gradient(119.5deg, rgba(75, 135, 145, 0.4), rgba(102, 192, 204, 0.3));
  $accent-color: #850A56;
  $gray-taupe-light: #F2F4F5;

  .home {
    .section-cover {
      display: flex;
      align-items: stretch;
      justify-content: center;
      width: 100%;
      overflow: visible;

      @media screen and (max-width: 480px) {
        width: 100%;
        display: block;
      }

      .cover {
        position: relative;
        width: 100%;



        &::before {
          content: "";
          width: 100%;
          height: 100%;
          z-index: 1;
        }

        .cover-image {
          width: 100%;
          object-fit: cover;
          z-index: 0;
        }

      }

      .container-btn {
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background: #FCFAF8;
        padding: 3rem;
        flex: 1;
        position: relative;
        z-index: 3;

        @media screen and (max-width: 480px) {
          width: 100%;
          padding: 24px;
          position: unset;
          margin-bottom: 0;

        }

        h1 {
          color: white;
          font-size: 2rem;
          font-weight: bold;
          margin-bottom: 1rem;

        }

        p {
          color: black !important;
          font-size: 1.2rem;
        }

        span {
          color: black !important;
          font-weight: 700;
          display: block;
          margin-top: 1rem;
        }

        .button {
          display: flex;
          gap: 2rem;
          margin-top: 1.5rem;
          margin-bottom: 2.5rem;
          justify-content: center;
        }
      }


      .scroll-btn {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 2rem;
        cursor: pointer;
        color: black;
        transition: transform 0.3s ease-in-out;
        z-index: 3;

        &:hover {
          transform: translateX(-50%) translateY(5px);
        }
      }
    }

    .brain-card {
      .card {
        min-height: 100%;
        text-align: center;
      }
    }


    .btn-wrapper {
      display: flex;
      justify-content: center;
      margin-top: 2rem;
      text-align: center;

      li {
        list-style: none !important;
      }

    }


    .list-offers {
      margin: auto;

      .card {

        :deep(.card-text) {
          margin-bottom: 60px;
        }
      }

    }

    #target {

      h2 {
        padding-top: 60px;
      }
    }

    .scroll-reveal {
      opacity: 0;
      transform: translateY(50px);
      transition: opacity 0.8s ease, transform 0.8s ease;
    }

    .scroll-reveal.visible {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media screen and (max-width: 768px) {
    .section-cover {
      .cover {
        background-size: cover;
      }

      .container-btn {
        width: 90%;
        padding: 1.5rem;

        h1 {
          font-size: 1.6rem;
        }

        p {
          font-size: 1rem;
        }

        .button {
          flex-direction: column;
          align-items: center;
        }
      }

      img {
        max-width: 100%;
        height: auto;
      }
    }
  }

  @media screen and (max-width: 480px) {
    .container-btn {
      width: 95%;
      padding: 1rem;

      h1 {
        font-size: 1.4rem;
      }

      p {
        font-size: 0.9rem;
      }

      .button {
        flex-direction: column;
      }
    }
  }
</style>